<template>
	<div class="details">
		<Commshop
		 :proData="transmitData"
		  />
		
		<div class="conten_body">  
			<div class="conten_left">
				
            
         <!-- 为什么选择万方？万方有什么优势？ -->
				<div class="con_list">
					<img class="" src="@/assets/images/testing/1-1/app st (1).jpg">
					<img class="" src="@/assets/images/testing/1-1/app st (2).jpg">
					<img class="" src="@/assets/images/testing/1-1/app st (3).jpg">
					<img class="" src="@/assets/images/testing/1-1/app st (4).jpg">
					<img class="" src="@/assets/images/testing/1-1/app st (5).jpg">
					<img class="" src="@/assets/images/testing/1-1/app st (6).jpg">
					
					
				</div>
				
				
			</div>
			<!-- right -->
			<Phone/>
			

		</div>
	</div>
</template>

<script type="text/javascript">
import Phone from "@/components/Phone.vue"
import Commshop from "@/components/Commshop.vue"
export default{
	components:{
      Phone,
      Commshop
	},
data(){
	return{
		transmitData:{
			title:"APP渗透测试",
			content:"APP渗透测试，对安卓APP客户端及对应服务端存在的安全风险进行深度检测，通过一系列分析和测试，最大限度发现系统中存在的技术和业务层面的安全问题",
            cc:"APP渗透测试，对安卓APP客户端及对应服务端存在的安全风险进行深度检测，通过一系列分析和测试，最大限度发现系统中存在的技术和业务层面的安全问题",
			price:'在线咨询',
			url:require('../../assets/images/testing/1-1/APP.jpg')
		}
	}
},
mounted(){

},
methods:{
	

}


};
</script>

<style type="text/css" lang="less" scoped>
.details{
	width:1200px;
	margin:0 auto;

//**/
.conten_body{
	margin-top:30px;
	overflow: hidden;
}
.conten_left{
	width:880px;
	float:left;
	background:#fff;
	box-sizing: border-box;
}
.nav_list{
	height:39px; 
   border-bottom: 1px solid #CFCDCD;
}
.nav_list li{
	float:left;
	width:120px;
	text-align:center;
}
.nav_list li a{
	display: inline-block;
	height:39px;
	font-size: 15px;
	line-height: 39px;
	color: #007CC6;
}
.nav_list li  .a_active{
   color:#007CC6;
   border-bottom:1px solid #007CC6;
}
.con_list{
	// padding:0 35px;
	overflow:hidden;
}
.con_list img{
	width:100%;
}





}


</style>







